import React, { useState, useRef, useMemo, useEffect } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  pourStateRecoil,
} from '../../atom/ModalAtom';
import { userIdState } from '../../atom/TokenAtom';
import { EntryListsDto, RoomInforDto } from '../../model/room.dto';
import { MyInforDto } from '../../model/user.dto';
import { socketio } from '../../api/socket.api';
import eventbus from '../../api/eventbus';
import { roomAPI } from '../../api/axiosIndex';

interface PourProps {
  pickLineId: number | null;
  onListUpdate: () => void;
}

const Pour = ({ pickLineId, onListUpdate }: PourProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(pourStateRecoil);

  const [minute, setMinute] = useState('0');

  const handleConfirm = async () => {
    if (minute === '') {
      setError(blankMsg);
      return;
    }

    try {
      await roomAPI.putPour(Number(pickLineId), Number(minute));
      socketio.entry(Number(pickLineId));
      setModalState(false);
      onListUpdate();
      setConfirm('타설 완료가 완료되었습니다.');
    } catch (err: any) {
      setError('타설 완료에 실패하였습니다.');
    }
  };

  return (
    <>
      <InputModal
        title="타설 완료"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          <li>
            <h2>시간(분)</h2>
            <CS.TextInputType1
              placeholder="시간(분) 입력"
              type="text"
              value={minute}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                setMinute(value);
              }}
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default Pour;
